<template>
    <div class="col-12 backgroundForm">
        <div class="alert alert-info" align="center" role="alert">
            <h4 class="alert-heading">Presupuesto</h4>
            <p>Registro y modificacion de Presupuestos (Anual y por partidas presupuestarias)</p>        
        </div>

        <nav>
            <div class="nav nav-tabs" id="nav-tab" role="tablist">
                <a class="nav-item nav-link active" id="nav-gral" data-toggle="tab" href="#nav-gral-poa" role="tab" aria-controls="nav-gral" aria-selected="true"><font-awesome-icon icon="plus" /> Registro <br>&nbsp&nbsp&nbsp Presupuesto Anual</a>

                <a class="nav-item nav-link" id="nav-update-gral" data-toggle="tab" href="#nav-update-poa" role="tab" aria-controls="nav-new" aria-selected="false"><font-awesome-icon icon="edit" /> Reformular <br> &nbsp&nbsp&nbsp&nbsp Presupuesto Anual</a>

                <a class="nav-item nav-link" id="nav-capitain" data-toggle="tab" href="#nav-budget-captain" role="tab" aria-controls="nav-new" aria-selected="false"><font-awesome-icon icon="plus" /> Presupuesto <br>&nbsp&nbsp&nbsp Capitanias</a>

                <a class="nav-item nav-link" id="nav-update-capitan" data-toggle="tab" href="#nav-budget-update" role="tab" aria-controls="nav-new" aria-selected="false"><font-awesome-icon icon="edit" /> Reformular <br>&nbsp&nbsp&nbsp&nbsp Presupuesto Capitanias</a>
            </div>
        </nav>

        <div class="tab-content" id="nav-tabContent">
            <!-- Asignacion de presupuesto anual -->
            <div class="tab-pane fade show active" id="nav-gral-poa" role="tabpanel" aria-labelledby="nav-capitan-tab">
                <br>
                <div class="row">
                    <div class="col-12 col-sm-6 offset-sm-3 alert alert-success" align="center">
                        Registrar Presupuesto Anual
                    </div>
                </div>

                <button class="btn btn-success col-12 col-sm-4 offset-sm-8" @click="mViewCeilingLast">
                    <font-awesome-icon icon="clipboard-list" size="2x"></font-awesome-icon> VER PRESUPUESTOS ANUALES
                </button>

                <div class="form-group row">
                    
                    <div class="col-12 col-sm-4 offset-sm-2">
                        <label for="new_code_budget">Gestion</label>
                        <select class="form-control" name="year_ceiling" v-model="year_ceiling" >
                            <option v-for="y in year_option_ceiling" :key="y.id" :value="y.id">{{ y.anio }}</option>
                        </select>
                    </div>
                    
                    <div class="col-12 col-sm-4">
                        <label for="new_code_budget">Importe Bs.</label>
                        <input type="number" class="form-control" placeholder="Ejm. 70000" name="new_code_budget" id="new_code_budget" v-model="import_celing_gral" >
                    </div>
                </div>
                <div align="center">
                                  
                    <button class="btn btn-danger" :disabled="cValidateSaveGral"  @click="mSaveCeilingGral"><font-awesome-icon icon="save" size="2x"></font-awesome-icon><br>Guardar</button>
                        
                </div>

            </div>
            
            <!-- reformulacion del poa -->
            <div class="tab-pane fade show" id="nav-update-poa" role="tabpanel" aria-labelledby="nav-capitan-tab">
                <br>                
                <div class="row">
                    <div class="col-12 col-sm-6 offset-sm-3 alert alert-info" align="center">
                        Reformulacion del Presupuesto
                    </div>
                </div>

                <button class="btn btn-success col-12 col-sm-4 offset-sm-8" @click="mViewCeilingLast">
                    <font-awesome-icon icon="clipboard-list" size="2x"></font-awesome-icon> VER PRESUPUESTOS ANUALES
                </button>

                <div class="form-group row">
                    
                    <div class="col-12 col-sm-4 offset-sm-2">
                        <label for="new_code_budget">Gestion</label>
                        <select class="form-control" name="year_ceiling" v-model="year_ceiling_update" >
                            <option v-for="y in year_option_ceiling" :key="y.id" :value="y.id">{{ y.anio }}</option>
                        </select>
                    </div>
                    
                    <div class="col-12 col-sm-4">
                        <label for="new_code_budget">Importe Bs.</label>
                        <input type="number" class="form-control" placeholder="Ejm. 70000" name="new_code_budget" id="new_code_budget" v-model="import_gral_update" >
                    </div>
                </div>
                <div class="form-group row">
                    <div class="col-12">
                        <label for="description_update">Descripcion de la Reformulacion del POA</label>
                        <textarea class="form-control" name="description_update" id="" cols="8" rows="4" v-model="ceiling_gral_description"></textarea>
                    </div>
                </div>
                <div align="center">
                                  
                    <button class="btn btn-warning" :disabled="cValidateUpdateGral"  @click="mSaveUpdateCeiling"><font-awesome-icon icon="sync-alt" size="2x"></font-awesome-icon><br>Actualizar</button>
                        
                </div>

            </div>

            <!-- Asignacion presupuesto a las capitanias -->
            <div class="tab-pane fade show" id="nav-budget-captain" role="tabpanel" aria-labelledby="nav-capitan-tab">
                <br>
                <div class="row">
                    <div class="col-12 col-sm-6 offset-sm-3 alert alert-dark" align="center">
                        Asignacion de Presupuestos y Partidas
                    </div>
                </div>
                <button class="btn btn-warning col-12 col-sm-4 offset-sm-8" @click="mViewCeilingDependencies">
                    <font-awesome-icon icon="clipboard-list" size="2x"></font-awesome-icon> PARTIDAS HABILITADAS
                </button>
                <div class="row">
                    <div class="form-group col-12 col-sm-4">
                        <label for="new_code_budget">Gestion</label>
                        <input type="text" readonly class="form-control-plaintext" id="staticYear" v-model="cYearVigent">
                    </div>
                    <div class="col-12 col-sm-4">
                        <label for="new_code_budget">Techo Presupuestario</label>
                        <div><span class="badge badge-danger">{{ ceilign_approv }}</span></div>
                    </div>
                    <div class="col-12 col-sm-4">
                        <label for="new_code_budget">Saldo Presupuesto Gral</label>
                        <div><span class="badge badge-dark">{{ saldo_ceiling }}</span></div>
                    </div>
                </div>
                
                <!-- <div class="form-group">                    
                    <label for="new_code_budget">Reparticion</label>
                    <select id="portCeiling" v-model="dependencie_assign_ceiling" class="form-control">
                        <option v-for="d in dependencies" :key="d.id" :value="d">{{ d.name_port }}</option>
                    </select>
                </div> -->
                <div class="row">
                    
                        <div class="form-group col-12 col-sm-6">
                    
                            <label for="new_code_budget">Partida</label>
                            <vue-bootstrap-typeahead                            
                                            v-model="query_budget"
                                            :data="budget_registers"
                                            :serializer="item => (item.code +' - '+item.description)"
                                            @hit="mSelectBudgetEspecify"
                                            :placeholder="searchBudget"                                        
                                />
                        </div>
                        <div class="col-12 col-sm-6">
                            <label for="new_code_budget">Partida Seleccionada</label>
                            <div><span class="badge badge-dark">{{ aux_query_budget.code }} - {{ aux_query_budget.description }}</span></div>
                        </div>
                    
                </div>

                <div class="form-group">
                    <label for="new_code_budget">Importe</label>
                    <input type="number" class="form-control" placeholder="Ejm. 15000" v-model="import_assign_dependencies">
                </div>
                
                <div align="center">
                                  
                    <button class="btn btn-danger" :disabled="cValSaveCeDep" @click="mSaveEspDependencie"><font-awesome-icon icon="save" size="2x"></font-awesome-icon><br>Registrar</button>
                        
                </div>
                
            </div>

            <!-- Modificacion del presupuesto a la reparticion -->
            <div class="tab-pane fade show" id="nav-budget-update" role="tabpanel" aria-labelledby="nav-capitan-tab">
                <br>
                <div class="row">
                    <div class="col-12 col-sm-6 offset-sm-3 alert alert-dark" align="center">
                        Reformulacion de la partida presupuestaria a la Reparticion
                    </div>
                </div>
                <div class="row">
                    <div class="form-group col-12 col-md-2 offset-md-5">
                        <label for="new_code_budget">Gestion</label>
                        <input type="text" readonly class="form-control-plaintext" id="staticYear" v-model="cYearVigent">
                    </div>
                    <!-- <div class="form-group">                    
                        <label for="new_code_budget">Reparticion</label>
                        <select id="portCeiling" v-model="dependencie_list_budget" class="form-control">
                            <option v-for="d in dependencies" :key="d.id" :value="d.id">{{ d.name_port }}</option>
                        </select>
                    </div> -->
                </div>

                <div align="center">
                                  
                    <button class="btn btn-success" @click="mListBudgetDependencie"><font-awesome-icon icon="list" size="2x"></font-awesome-icon><br>Listar Partidas</button>
                        
                </div>
                <br>
                <transition name="fade" mode="out-in">                
                <div class="col-12 table-responsive" v-if="budget_assign_dependencie.length > 0">
                    <table class="table table-bordered">
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>Codigo</th>
                                <th>Partida</th>
                                <th>Importe</th>
                                <th>Editar</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(cd, index) in budget_assign_dependencie" :key="cd.code_assign">
                                <td>{{ index+1 }}</td>
                                <td>{{ cd.budget_code }}</td>
                                <td>{{ cd.glosa }}</td>
                                <td><input class="form-control" disabled type="number" :id="`imp_bud_dep_${index}`" :name="`imp_bud_dep_${index}`" v-model="cd.import_budget" ></td>
                                <td>
                                    <button class="btn btn-warning" :id="`btn_edit_imp_${index}`" @click="editRegisterImport(index)"><font-awesome-icon icon="edit" /></button>

                                    <div style="display:none" :id="`edit_cancel_imp_${index}`">
                                        <button class="btn btn-success" @click="saveBudgetImport(index)"><font-awesome-icon icon="save" /></button>
                                        <button class="btn btn-danger" @click="cancelEditImport(index)"><font-awesome-icon icon="times-circle" /></button>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                </transition>
            </div>

        </div>
        <modal-loading :id-modal="id_modal_progress" :title="title_modal" :status-send="send_dispatch" ></modal-loading>
        <modal-view :id-modal-view="id_modal_content" :title="title_modal_view" :is-xl="type_modal" :content="content_modal_view" ></modal-view>
    </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios';
import vue from 'vue';
const qs = require('qs');
import numeral from 'numeral';

import modalLoading from '../modal/modalLoading';
import modalView from '../modal/modalView';

export default {
    data(){
        return{
            id_modal_progress:'modalSendCeiling',
            title_modal:'Registrando',
            send_dispatch:true,
            year_ceiling:null,
            year_ceiling_update:null,
            year_option_ceiling:[],
            import_celing_gral:null,
            import_gral_update:null,
            ceiling_gral_description:'',
            btn_save_gral:true,
            dependencie_assign_ceiling:{id:0, name_port:''},
            dependencies:[],
            import_assign_dependencies:null,
            query_budget:null,
            aux_query_budget:{code:0, description:''},
            budget_registers:[],
            searchBudget:'Partida Presupuestaria',
            ceilign_approv:0,
            saldo_ceiling:0,
            id_modal_content:'viewDtsCeiling',
            title_modal_view:'Partidas Asiganadas',
            type_modal:true,
            content_modal_view:'<h5>Sin Registros</h5>',
            dependencie_list_budget:null,
            budget_assign_dependencie:[],
            budget_import_edit:[]
        }
    },
    mounted(){
        this.mObtainYear();
        this.mSelectDependencies();
        this.mCallCeiling();
    },
    methods:{
        editRegisterImport(i){
            // console.log(`el valor a editar es ${i}`);
            let ti= document.getElementById(`imp_bud_dep_${i}`);
            
            let btn_edit= document.getElementById(`btn_edit_imp_${i}`);
            let save_cancel= document.getElementById(`edit_cancel_imp_${i}`);
            let ab={
                code:null,
                budget_code:null,
                import_budget:null,
                captain:null
            }

            ti.removeAttribute('disabled');

            btn_edit.style.display='none';
            // save_cancel.style.display = 'block';
            save_cancel.removeAttribute('style');
            // validar si ya esta registrado el codigo
            ab.code=this.budget_assign_dependencie[i].code_assign;
            ab.budget_code=this.budget_assign_dependencie[i].budget_code;
            ab.import_budget=this.budget_assign_dependencie[i].import_budget;
            ab.captain=this.budget_assign_dependencie[i].captain;

            this.budget_import_edit.push(ab);
            
            // aqui buscamos el codigo que se va a editar y guardarlo en una variable por si se decide no guardar
        },
        cancelEditImport(i){
            // al cancelar la edicion se debe vaciar los datos del auxiliar al original de los datos
            let ti = document.getElementById(`imp_bud_dep_${i}`);
            
            let btn_edit_i= document.getElementById(`btn_edit_imp_${i}`);
            let save_cancel= document.getElementById(`edit_cancel_imp_${i}`);
            
            let code_aux;
            let auxBudget;
            let idel;
            // obtenemos el codigo del original y lo buscamos en el auxiliar para luego vaciarlo
            code_aux=this.budget_assign_dependencie[i].code_assign;
            let c_b=this.budget_assign_dependencie[i].budget_code;
            toastr.warning(`Se ha cancelado la modificacion del registro ${c_b}`, 'Advertencia');
            // console.log(this.BudgetEdit);
            // vaciamos del auxiliar al original
            this.budget_import_edit.forEach((v, key)=>{
                if(code_aux===v.code){
                    auxBudget={
                        code:v.code,
                        budget_code:v.budget_code,
                        import_budget:v.import_budget,
                        captain:v.captain
                    }
                    idel=key;
                }
            });
            // posteriormente eliminar la copia en el auxiliar
            
            this.budget_import_edit.splice(idel, 1);
            // console.log(this.BudgetEdit);
            // console.log(`el valor a reemplazar es ${auxBudget}`);
            // console.log(auxBudget);
            this.budget_assign_dependencie[i].import_budget=auxBudget.import_budget;
            // this.budget_assign_dependencie[i].glosa=auxBudget.glosa;

            ti.setAttribute('disabled', 'disabled');
            // dm.setAttribute('disabled', 'disabled');
            btn_edit_i.removeAttribute('style');
            save_cancel.style.display='none';
            

        },
        async saveBudgetImport(i){
                        
            let btn_edit= document.getElementById(`btn_edit_imp_${i}`);
            let save_cancel= document.getElementById(`edit_cancel_imp_${i}`);
            let ti = document.getElementById(`imp_bud_dep_${i}`);

            let idel;
            let code_aux;
            let sendAux;

            let message = {
                title: 'Actualizar Presupuesto',
                body: '¿Desea Actualizar el Presupuesto?'
            };

            let npr=new Promise((resolve, reject)=>{
                this.$dialog
                .confirm(message)
                .then(function(dialog) {
                    resolve(true);          
                })
                .catch(function() {
                    resolve(false);
                });
            });
            
            npr.then(async (msg)=>{
                if(msg){
                    // registramos y validamos el presupuesto general en la bd
                    try {
                    // enviamos al servidor la nueva actualizacion del codigo
                    sendAux={
                        code_assign:this.budget_assign_dependencie[i].code_assign,
                        budget_code:this.budget_assign_dependencie[i].budget_code,
                        import_budget:this.budget_assign_dependencie[i].import_budget
                        // captain:this.budget_assign_dependencie[i].captain
                    }
                    
                    ti.setAttribute('disabled', 'disabled');
                    
                    btn_edit.removeAttribute('style');
                    save_cancel.style.display='none';

                    
                    this.title_modal='Actualizando';
                    this.activeModal(this.id_modal_progress);
                    let respServImp=await axios.post(`updateImportDep?api_token=${Vue.auth.getToken()}`, qs.stringify(sendAux));
                    

                    setTimeout(()=>{
                        if(respServImp.data.status){
                            // si es verdad eliminamos el valor
                            toastr.success(respServImp.data.response, 'Exito');
                                code_aux=this.budget_assign_dependencie[i].code_assign;
                                this.budget_import_edit.forEach((v, key)=>{
                                    if(code_aux===v.code_assign){
                                        idel=key;
                                    }
                                });
                            // posteriormente eliminar la copia en el auxiliar            
                            this.budget_import_edit.splice(idel, 1);
                        }else{
                            toastr.error(respServImp.data.response, 'Error');
                            // si es error mantenemos el antiguo valor
                            let auxBudget;
                            code_aux=this.budget_assign_dependencie[i].code_assign;
                            
                            this.budget_import_edit.forEach((v, key)=>{
                                if(code_aux===v.code){
                                    auxBudget={
                                        code:v.code,
                                        budget_code:v.budget_code,
                                        import_budget:v.import_budget,
                                        captain:v.captain
                                    }
                                    idel=key;
                                }
                            });
                            
                            this.budget_import_edit.splice(idel, 1);
                            
                            this.budget_assign_dependencie[i].import_budget=auxBudget.import_budget;
                        }
                        this.inactiveModal(this.id_modal_progress);
                    }, 500)
                    }catch(err){
                        toastr.error('Consulte al administrador', 'Error');
                        this.inactiveModal(this.id_modal_progress);
                    }
                }else{
                    console.log('se ha rechazado la actualizacion del registro')
                }
            })
        },
        async mSelectDependencies(){
            // let dr=await axios.get('getAllDependecies');
            let dr=await axios.get(`getAllDependecies?api_token=${Vue.auth.getToken()}`);
            this.dependencies=dr.data;
        },
        mSelectBudgetEspecify(data){            
            this.aux_query_budget.code=data.code;
            this.aux_query_budget.description=data.description;
        },
        mObtainYear(){
            let anio=new Date();
            for(let i = 0 ; i<=1 ;i++){
                let auxYear={
                    id:anio.getFullYear()+i,
                    anio:anio.getFullYear()+i
                }
                this.year_option_ceiling.push(auxYear);
            }
        },
        mSaveCeilingGral(){
            let message = {
                title: 'Registrar Presupuesto',
                body: '¿Desea Registrar el Presupuesto?'
            };

            let npr=new Promise((resolve, reject)=>{
                this.$dialog
                .confirm(message)
                .then(function(dialog) {
                    resolve(true);          
                })
                .catch(function() {
                    resolve(false);
                });
            })
            npr.then(async (msg)=>{
                if(msg){
                    // registramos y validamos el presupuesto general en la bd
                    try {
                        this.activeModal(this.id_modal_progress);
                        let auxCeiling={
                            gest:this.year_ceiling,
                            import:this.import_celing_gral
                        }
                        this.import_celing_gral=null;
                        // let rr=await axios.post(`regBudgetCeiling`, qs.stringify(auxCeiling));
                        let rr=await axios.post(`regBudgetCeiling?api_token=${Vue.auth.getToken()}`, qs.stringify(auxCeiling));
                        setTimeout(()=>{
                            if(rr.data.status){
                                toastr.success(rr.data.response, 'Exito');
                            }else{
                                toastr.error(rr.data.response, 'Error');
                            }
                            this.inactiveModal(this.id_modal_progress);
                        }, 500)           
                    } catch (error) {
                        toastr.error('la gestion ya se encuentra registrada', 'Error');
                        this.inactiveModal(this.id_modal_progress);
                    }
                }else{
                    console.log('se ha rechazado el registro')
                }
            })
        },
        async mListBudgetDependencie(){
            // let ra=await axios.get(`getListCeiling/${this.dependencie_list_budget}/${this.cYearVigent}`);
            let ra=await axios.get(`getListCeiling/${this.cYearVigent}?api_token=${Vue.auth.getToken()}`);
            // console.log(ra.data);
            this.budget_assign_dependencie=ra.data;
        },
        mSaveUpdateCeiling(){
            let message = {
                title: 'Actualizar Presupuesto',
                body: 'Esta Seguro de Enviar los datos?'
            };

            let npr=new Promise((resolve, reject)=>{
                this.$dialog
                .confirm(message)
                .then(function(dialog) {
                    resolve(true);          
                })
                .catch(function() {
                    resolve(false);
                });
            })
            npr.then(async (msg)=>{
                if(msg){

                    try {
                        this.title_modal="Actualizando";
                        this.activeModal(this.id_modal_progress);
                        let np={
                            gest:this.year_ceiling_update,
                            import:this.import_gral_update,
                            des:this.ceiling_gral_description
                        };
                        this.import_gral_update=null;
                        this.ceiling_gral_description='';
                        // let rug=await axios.post(`updateBudgetCeiling`, qs.stringify(np));
                        let rug=await axios.post(`updateBudgetCeiling?api_token=${Vue.auth.getToken()}`, qs.stringify(np));
                        setTimeout(()=>{
                            if(rug.data.status){
                                toastr.success(rug.data.response, 'Exito');
                            }else{
                                toastr.error(rug.data.response, 'Error');
                            }
                            this.inactiveModal(this.id_modal_progress);
                        }, 500);   
                    } catch (error) {
                        toastr.error("Ha ocurrido un error consulte al administrador", 'Error');
                        this.inactiveModal(this.id_modal_progress);
                    }
                }else{
                    console.log('se ha rechazado la actualizacion')
                }
            })               
        },
        mSaveEspDependencie(){
            // registramos el presupuesto a la capitania
            let message = {
                title: 'Asignar presupuesto',
                body: `Desea registrar la partida y el presupuesto para la gestion?`
            };

            let npr=new Promise((resolve, reject)=>{
                this.$dialog
                .confirm(message)
                .then(function(dialog) {
                    resolve(true);          
                })
                .catch(function() {
                    resolve(false);
                });
            })
            npr.then(async (msg)=>{
                if(msg){
                    try {
                        this.title_modal="Registrando";
                        this.activeModal(this.id_modal_progress);
                        // colocamos el presupuesto sin capitania solo general
                        let npe={
                            year:this.cYearVigent,
                            // dependencie:this.dependencie_assign_ceiling.id,
                            budget_code:this.aux_query_budget.code,
                            import:this.import_assign_dependencies
                        };
                        // console.log(this.aux_query_budget.code);
                        this.import_gral_update=null;
                        this.ceiling_gral_description='';
                        // let rug=await axios.post(`saveBudgetDep`, qs.stringify(npe));
                        let rug=await axios.post(`saveBudgetDep?api_token=${Vue.auth.getToken()}`, qs.stringify(npe));
                        setTimeout(()=>{
                            if(rug.data.status){
                                this.mCallCeiling();
                                toastr.success(rug.data.response, 'Exito');
                                this.import_assign_dependencies=null;
                            }else{
                                toastr.error(rug.data.response, 'Error');
                            }
                            this.inactiveModal(this.id_modal_progress);
                        }, 500);
                    } catch (error) {
                        toastr.error("Verifique que la partida no este registrada", 'Error');
                        this.inactiveModal(this.id_modal_progress);
                    }
                }else{
                    console.log('se ha rechazado la actualizacion')
                }
            })            
        },
        activeModal(e){
            $(`#${e}`).modal('show');
        },
        inactiveModal(e){
            $(`#${e}`).modal('hide');
        },
        async mCallCeiling(){
            
            // let ceilingGral=await axios.get(`getCeilingGral/${this.cYearVigent}/1`);
            // let saldoCeiling=await axios.get(`getSaldoCeiling/${this.cYearVigent}/2`);
            let ceilingGral=await axios.get(`getCeilingGral/${this.cYearVigent}/1?api_token=${Vue.auth.getToken()}`);
            let saldoCeiling=await axios.get(`getSaldoCeiling/${this.cYearVigent}/2?api_token=${Vue.auth.getToken()}`);
            let g=ceilingGral.data;
            
            this.ceilign_approv=g.length > 0 ? g[0].import_budget : 0;
            // console.log(ceilingGral);
            this.saldo_ceiling=this.ceilign_approv-saldoCeiling.data;
            // console.log(saldoCeiling);
            
        },
        async mViewCeilingDependencies(){
            // if(this.dependencie_assign_ceiling.id>0){
                // console.log(`de la capitania ${this.dependencie_assign_ceiling.id}`);
                // let rs=await axios.get(`getCeilingRegister/${this.cYearVigent}/${this.dependencie_assign_ceiling.id}`);
                let rs=await axios.get(`getCeilingRegister/${this.cYearVigent}?api_token=${Vue.auth.getToken()}`);
                // console.log(rs);

                this.title_modal_view=`PARTIDAS HABILITADAS EN LA GESTION ${this.cYearVigent}`;
            
                let rc=rs.data;
                let dt='';
                // base de columnas de tablas es 5 ya que son solo 5 digitos
                dt=`<table class="table">
                    <thead>
                        <tr>
                            <th scope="col">#</th>
                            <th scope="col">Codigo</th>
                            <th scope="col">Titulo</th>
                            <th scope="col">Importe</th>
                        </tr>
                    </thead>
                    <tbody>`;
                let sp=0;
                rc.forEach( (e,index) => {
                    let imp=numeral(e.import_budget).format('0,0.0');
                    dt+=`<tr>
                        <td align="left">${index+1}</td>
                        <td align="left">${e.code}</td>
                        <td align="left">${e.glosa}</td>
                        <td colspan="4" align="left">${imp}</td>
                    </tr>`;
                    sp+=parseFloat(e.import_budget);
                });
                let spaux=numeral(sp.toFixed(1)).format('0,0.0');
                dt+=`<tr><td colspan="3" align="right"><b>Total</b></td><td><b>${spaux}</b></td></tr>
                </tbody></table>`;
                this.content_modal_view=dt;
                this.activeModal(this.id_modal_content);

            // }else{
            //     toastr.warning("Seleccione una Reparticion", "Advertencia");
            // }
        },
        async mViewCeilingLast(){
            // llamamos a las 5 ultimas gestiones
            // let fiveCeiling=await axios.get(`getFiveYears`);
            let fiveCeiling=await axios.get(`getFiveYears?api_token=${Vue.auth.getToken()}`);
            let rf=fiveCeiling.data;
            if(rf.length > 0){
                
                this.title_modal_view = `PRESUPUESTOS DE LAS 5 ULTIMAS GESTIONES`;
            
                
                let dt='';
                // base de columnas de tablas es 5 ya que son solo 5 digitos
                dt=`<table class="table">
                    <thead>
                        <tr>
                            <th scope="col">#</th>
                            <th scope="col">Gestion</th>
                            <th scope="col">Importe</th>
                        </tr>
                    </thead>
                    <tbody>`;
                
                rf.forEach( (e,index) => {
                    let impaux=numeral(e.import).format('0,0.0');
                    dt+=`<tr>
                        <td align="left">${index+1}</td>
                        <td align="left">${e.year}</td>
                        <td align="left">${impaux}</td>
                    </tr>`;
                    
                });
                
                dt+=`</tbody></table>`;
                this.content_modal_view=dt;
                this.activeModal(this.id_modal_content);
            }else{
                this.content_modal_view='<h5>Sin Registros</h5>'
            }

        }
    },
    computed:{
        cValidateSaveGral(){
            if(this.year_ceiling > 0 && this.import_celing_gral >0 ){
                return false;
            }else{
                return true;
            }
        },
        cValidateUpdateGral(){
            let cd=this.ceiling_gral_description;
            if(this.year_ceiling_update>0 && this.import_gral_update>0 && cd.length > 10){
                return false;
            }else{
                return true;
            }
        },
        cValSaveCeDep(){
            let va=this.aux_query_budget.code;
            // let cd=this.dependencie_assign_ceiling.id;
            
            // if(cd > 0 && this.import_assign_dependencies > 0 && va.length > 0){
            if(this.import_assign_dependencies > 0 && va.length > 0){
                return false;
            }else{
                return true;
            }
        },
        cYearVigent(){
            let anio=new Date();
            return anio.getUTCFullYear();
            // return 2020;
        }
    },
    watch:{
        query_budget(newBudget) {
            // axios.get(`getAllBudget/${newBudget}`)
            axios.get(`getAllBudget/${newBudget}?api_token=${Vue.auth.getToken()}`)
                .then((res) => {                    
                    this.budget_registers = res.data
                    // this.users = res.data.items
                }).catch(error => {
                    console.log(error);
                })               
        }
    },
    components:{
        'modal-loading':modalLoading,
        'modal-view':modalView
    }
}
</script>


// WEBPACK FOOTER //
// src/components/finanzas/BudgetCeiling.vue